import { DirectiveOptions } from 'vue';
import { formatter } from '../app.config';
import Calculator from '../helpers/calculator';
import { ICombination, IFlight, IPriceCombination, ITour } from '../store/models';

const updatePrice = (el: HTMLElement, sid: ITour['sid'], cSid: ICombination['sid'], flights: IFlight[], format: string): void => {
    const flight = flights.find(({ tourSid }) => tourSid === sid);

    el.classList.remove('u-d-none'); // because flight state could be changed
    if (!flight) {
        el.innerHTML = '';
        el.classList.add('u-d-none');

        return;
    }
    const prices: IPriceCombination[] = flight.prices.flatMap(({ combinations }) => combinations.filter(({ combinationSid }) => combinationSid === cSid));
    const price = Calculator.minPrice(prices.map(({ suppPrice }) => suppPrice));
    if (!price) {
        el.innerHTML = '';
        el.classList.add('u-d-none');

        return;
    }
    el.innerHTML = format.replace('%s', formatter.asRatio(price));
    el.classList.add('is-price-loaded');
};

const minExtensionPrice: DirectiveOptions = {
    bind(el, { value }): void {
        updatePrice(el, value.sid, value.cSid, value.flights, value.format || '%s');
    },
    componentUpdated(el, { value }): void {
        updatePrice(el, value.sid, value.cSid, value.flights, value.format || '%s');
    },
};

export default minExtensionPrice;
